// 搜索项字段 code 映射，便于复用和避免硬编码
export const DocSearchCodes = {
  projectName: 'projectName', // 资料包名称
  engName: 'gcmc1', // 工程名称
  engCode: 'gcmc', // 工程编号
  projectType: 'gclx', // 工程类型
  projectStatus: 'gczt', // 工程状态
  docStatus: 'docStatus', // 资料状态
  startDate: 'kgrq', // 开工日期
  endDate: 'jgrq', // 竣工日期
  orgIds: 'orgIds', // 部门组织
} as const

export type DocSearchCode = (typeof DocSearchCodes)[keyof typeof DocSearchCodes]
